export const CameraControlTypes = {
  Orbit: 0,
  Map: 1,
}

export const CameraControlTypeDisplayNames = {
  [CameraControlTypes.Orbit]: 'Orbit',
  [CameraControlTypes.Map]: 'Map',
}
